<template>
  <div class="rechargeLog-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.channel"
        class="param-input"
        clearable
        @keyup.enter.native="getList('status')"
        size="small"
        placeholder="输入渠道"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        @change="changeTime"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="getList('status')">查询</el-button>
      <el-button type="primary" size="small" @click="exportdata">导出</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table
      height="650"
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="sumDate" label="日期" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.sumDate | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="渠道" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.channel || '未知'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="completeRate" label="完成率" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.completeRate || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column label="完成率趋势图" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="clickOpenEchartPopup({channel:scope.row.channel,sumDate:scope.row.sumDate})"
            type="info"
          >详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="orderCount" label="生产订单数" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.orderCount || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="completeOrderCount" label="完成订单数" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.completeOrderCount || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderAmount" label="订单金额" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.orderAmount/100 || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="completeOrderAmount" label="实际支付金额" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.completeOrderAmount/100 || 0) | numFormat}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="paidOrderCount" label="付款订单数" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.paidOrderCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="paidAmount" label="付款金额" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.paidAmount/100 || 0) | numFormat}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <EchartPopup v-if="hasEchartPopup" ref="EchartPopup"></EchartPopup>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import {changeTime, paramsFilter} from "@/utils/global";
import API from "@/api";
import EchartPopup from "./components/echartPopup.vue";

export default {
  data() {
    return {
      // 时间数据绑定字段
      time: "",
      loading: false,
      total: 0,
      hasEchartPopup: false,
      // 列表参数
      params: {
        pageNumber: 1,
        pageSize: 20,
        sortValue: "",
        start: "",
        end: "",
      },
      tableData: [],
    };
  },
  components: {
    EchartPopup,
  },
  created() {
    this.getList();
  },
  methods: {
    clickOpenEchartPopup(data) {
      this.hasEchartPopup = true;
      this.$nextTick(() => {
        this.$refs.EchartPopup.open(data);
      });
    },
    // 请求列表数据
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      // type为1 为充值成功数据
      let params = Object.assign({}, this.params, { type: 1 });
      this.loading = true;
      API.getOrderStats(params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.total = 0;
          this.loading = false;
        });
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter(this.params);
      let str = "";
      for (let key in params) {
        if (key == "start" || key == "end") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str + "type=1";
      let url = baseConfig.baseServerUrl + "/export/orderStat?" + str;
      window.location.href = url;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getList("status");
    },
  },
};
</script>
